import depLawRoad from '@src/pages/Law/AccountManage/weixin/roadMap';
export default {
    result: {
        la: depLawRoad(),
    },
    models: {
        depLawRoad,
    },
};
